
import { Button } from "@/components/ui/button";
import { Filter } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

interface TipsTableHeaderProps {
  showArchived: boolean;
  onToggleArchived: () => void;
  onAddTip: () => void;
  statusFilter: string;
  onStatusFilterChange: (value: string) => void;
  universityFilter: string;
  onUniversityFilterChange: (value: string) => void;
}

interface University {
  id: number;
  name: string;
}

export function TipsTableHeader({ 
  showArchived, 
  onToggleArchived, 
  onAddTip,
  statusFilter,
  onStatusFilterChange,
  universityFilter,
  onUniversityFilterChange
}: TipsTableHeaderProps) {
  const [universities, setUniversities] = useState<University[]>([]);

  useEffect(() => {
    const fetchUniversities = async () => {
      const { data, error } = await supabase
        .from('universities')
        .select('id, name');
      
      if (!error && data) {
        setUniversities(data);
      }
    };

    fetchUniversities();
  }, []);

  return (
    <div className="flex justify-between items-center mb-4">
      <div className="flex items-center gap-4">
        <h2 className="text-xl font-semibold">Tips Management</h2>
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onToggleArchived}
            className="gap-2"
          >
            <Filter className="h-4 w-4" />
            {showArchived ? "Hide Archived" : "Show Archived"}
          </Button>
          <Select value={statusFilter} onValueChange={onStatusFilterChange}>
            <SelectTrigger className="w-[140px]">
              <SelectValue placeholder="Filter by status" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Status</SelectItem>
              <SelectItem value="approved">Approved</SelectItem>
              <SelectItem value="draft">Draft</SelectItem>
            </SelectContent>
          </Select>
          <Select value={universityFilter} onValueChange={onUniversityFilterChange}>
            <SelectTrigger className="w-[180px]">
              <SelectValue placeholder="Filter by university" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all_tips">All Tips</SelectItem>
              <SelectItem value="all_universities">All Universities</SelectItem>
              {universities.map((university) => (
                <SelectItem key={university.id} value={university.id.toString()}>
                  {university.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>
      <Button size="sm" onClick={onAddTip}>
        Add Tip
      </Button>
    </div>
  );
}
